import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Growth = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Growth({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M18.5585 1.95296C18.8318 1.99223 19.0216 2.24564 18.9823 2.51898L17.5476 12.5057C17.4839 12.9497 16.913 13.0916 16.6487 12.7292L14.8054 10.2014L9.68538 16.846C9.52155 17.0586 9.21908 17.1039 9.00012 16.9487L5.53567 14.4923L1.48458 18.0038C1.09562 18.341 0.51243 17.9412 0.686568 17.4568L3.85711 8.63718C3.95904 8.35364 4.28674 8.22399 4.55507 8.36105L7.6045 9.91867L10.4931 4.28783L8.34655 1.3437C8.08592 0.986233 8.38377 0.491304 8.82167 0.554211L18.5585 1.95296ZM12.2501 4.15152L8.48384 11.4912C8.35795 11.7365 8.0572 11.8336 7.81161 11.7082L5.39026 10.4718C5.12196 10.3348 4.79432 10.4645 4.69238 10.748L3.39111 14.3667L5.14658 12.8463C5.32061 12.6956 5.57506 12.6832 5.76293 12.8163L8.69204 14.8911C8.91099 15.0462 9.21331 15.0009 9.37709 14.7883L14.839 7.70123L16.4124 9.859L17.3553 3.29552L10.9562 2.37624L12.2501 4.15152Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'growth-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Growth;
